import { sourceContext } from "../../constants/contextUrlConfig";

export class ContextUrlProvider {
  constructor(contextName) {
    this.contextName = contextName;
    this.context = sourceContext.find(c => c.contextName === this.contextName);
  }

  getUrl = keys => {
    return this.context ? this.context.getUrl(keys) : "";
  };
}
